<script type="module" lang="ts">
export const dialogProvideKey = Symbol() as InjectionKey<{ close: () => void }>
</script>
<script setup lang="ts">
defineOptions({
  inheritAttrs: false,
})

const open = defineModel<boolean>("open")
const emit = defineEmits(["close"])
function close() {
  open.value = false
  emit("close")
}

// Provide `close` function to all children in component tree.
// Used by `DialogHeader` to close nearest Dialog
provide(dialogProvideKey, {
  close,
})
</script>
<template>
  <DialogWrapper v-model:open="open" @close="close">
    <Transition
      enter-active-class="duration-200 ease-out"
      enter-from-class="transform opacity-0 translate-y-40"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="duration-200 ease-in"
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="transform opacity-0 translate-y-40"
      appear
    >
      <dialog
        ref="modal"
        class="relative max-h-[95svh] w-full max-w-2xl flex-col overflow-auto rounded-t-lg bg-white text-left shadow-xl transition-all sm:top-8 sm:mx-auto sm:rounded-lg"
        :open
        role="dialog"
        aria-modal="true"
        v-bind="$attrs"
        aria-labelledby="modal-headline"
      >
        <slot />
      </dialog>
    </Transition>
  </DialogWrapper>
</template>
